module.exports = __webpack_public_path__ + "static/media/ipad-01.6f385941.png";